// Add here the endpoints for MS Graph API services you would like to use.
const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages",
    graphPhotoEndpoint : "https://graph.microsoft.com/v1.0/me/photo/$value",
    graphPhotoEndpoint48x48 : "https://graph.microsoft.com/v1.0/me/photos/48x48/$value",
    graphContactsEndpoint: "https://graph.microsoft.com/v1.0/me/people?$top=2000",
    graphMembersEndPoint:"https://graph.microsoft.com/v1.0/users",
    grpahUserPhoto:"https://graph.microsoft.com/v1.0/users/",
  };

  export default graphConfig 